import useBaseScreen from '@unifyapps/hooks/useScreen';
import { DeviceVariantType } from '@unifyapps/hooks/useScreen/types';
import { type ClientContextValue, ClientType, useClientContext } from '../context/client';

const shouldForceDesktop = ({ client }: ClientContextValue) => {
  // Every matrix-extension surface opens matrix in a small-width iframe, so media
  // queries report mobile, which is not what we want. This used to allowlist only the
  // Google apps; the Office add-in (and any future extension host) has the same narrow
  // iframe, so the per-app check under-matched and was widened to the client type.
  return client === ClientType.MatrixExtension;
};

export const useScreen = () => {
  const baseScreen = useBaseScreen();
  const clientContext = useClientContext();

  const screen =
    clientContext && shouldForceDesktop(clientContext)
      ? DeviceVariantType.DESKTOP
      : baseScreen.screen;

  // Re-evaluating the booleans here since screen is re-evaluated above based on the client context
  const isDesktop = screen === DeviceVariantType.DESKTOP;
  const isTablet = screen === DeviceVariantType.TABLET;
  const isMobile = screen === DeviceVariantType.MOBILE;

  return {
    ...baseScreen,
    screen,
    isDesktop,
    isTablet,
    isMobile,
  };
};
